module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "iframe-container"
  }, [(_vm.permission) ? [_c('iframe', {
    attrs: {
      "src": _vm.ifameSrc,
      "id": "biz-frame",
      "frameborder": "0",
      "width": "100%",
      "height": "820px",
      "scrolling": "auto"
    }
  })] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae876f2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/iframe.vue
// module id = 298
// module chunks = 25